import { AguiChatClient } from '@langbridge-builder/chat-ui/agui';
import { abortRun, authHeaders, buildRunQuery, createSession, type LangbridgeConfig } from './api';
import type { AgentIo } from './types';
import { uploadAttachments } from './upload';

/**
 * Build an AG-UI chat client bound to one agent + connection. `io` (optional)
 * shapes the query payload; without it the client falls back to `{ query: text }`.
 * Pass `threadId` to resume a restored past session (skips createSession so runs
 * continue that session's checkpointed state); omit it for a fresh conversation.
 * Shared by /connect, the studio live preview, and the desktop app so all stream identically.
 */
export function makeAguiClient(
  config: LangbridgeConfig,
  agentId: string,
  io: AgentIo | null,
  threadId?: string,
): AguiChatClient {
  return new AguiChatClient({
    apiBase: config.apiBase,
    agentId,
    headers: authHeaders(config),
    buildQuery: io ? (text, attachments) => buildRunQuery(io, text, attachments) : undefined,
    // Upload local files to storage first so the agent receives public `url`
    // parts, not inline base64 (web → presign+PUT; desktop → central proxy).
    prepareAttachments: (attachments) => uploadAttachments(attachments, config),
    createSession: (aid) => createSession(config, aid),
    onAbort: (tid) => {
      if (tid) void abortRun(config, tid);
    },
    ...(threadId ? { threadId } : {}),
  });
}
